function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#F3F4F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6515 13.6509C11.6515 13.927 11.4276 14.1509 11.1515 14.1509H5.89063C5.61448 14.1509 5.39062 13.927 5.39062 13.6509V13.2596C5.39062 12.9834 5.61448 12.7596 5.89062 12.7596H11.1515C11.4276 12.7596 11.6515 12.9834 11.6515 13.2596V13.6509ZM14.4341 10.8682C14.4341 11.1444 14.2102 11.3682 13.9341 11.3682H5.89062C5.61448 11.3682 5.39062 11.1444 5.39062 10.8682V10.4769C5.39062 10.2008 5.61448 9.97694 5.89062 9.97694H13.9341C14.2102 9.97694 14.4341 10.2008 14.4341 10.4769V10.8682ZM14.4341 8.08564C14.4341 8.36178 14.2102 8.58564 13.9341 8.58564H5.89062C5.61448 8.58564 5.39062 8.36178 5.39062 8.08564V7.69434C5.39062 7.41819 5.61448 7.19434 5.89062 7.19434H13.9341C14.2102 7.19434 14.4341 7.41819 14.4341 7.69434V8.08564Z",
  fill: "#707274"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8263 18.6087V13.0435",
  stroke: "#707274",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8269 13.0434L13.857 14.914",
  stroke: "#707274",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8254 13.0577L17.7954 14.9283",
  stroke: "#707274",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.0a2f3bdd.svg";
export { ForwardRef as ReactComponent };